import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import mensagens from '@/util/mensagens'
import { BSpinner, BToast } from 'bootstrap-vue'
import { mapState } from 'vuex'
import redirecionamento from '@/util/redirecionamentoRotasConteudo'
import util from '@/util'

export default {
  name: 'detalhes-noticias',
  components: {
    cabecalho,
    menuLateral,
    'b-spinner': BSpinner,
    'b-toast': BToast
  },

  computed: {
    ...mapState('auth', ['tipoDeAcesso'])
  },

  data: () => {
    return {
      noticia: [],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      dataHoraFormatada: null
    }
  },

  mounted () {
    this.obterNoticia(this.$route.params.id)
  },

  methods: {
    async obterNoticia (id) {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        const resposta = await this.axios.get('/noticias/noticia/' + id)
        this.noticia = resposta.data.retorno.dados
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    voltarRotaAnterior () {
      this.$router.push({ name: redirecionamento.obterRota(this.tipoDeAcesso, 'noticias') })
    },

    formatarDataHora (data) {
      return util.formatarData(data, 'DD/MM/YYYY')
    }
  }
}
